import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
// Apps
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'
import './index.scss'

// import {App} from './app/App'
import {AppRoutes} from './app/routing/AppRoutes'
import {setupAxios} from './app/modules/auth'
import store, {persistor} from './app/store/store'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'

// Add auth helper to authenticate api requests
setupAxios(axios, store)

setTimeout(() => {
  console.log('Rendering: index.tsx *******************************************')
  const container = document.getElementById('root')
  if (container) {
    createRoot(container).render(
      <Provider store={store}>
        {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
        <PersistGate persistor={persistor}>
          <AppRoutes />
        </PersistGate>
      </Provider>
    )
  }
})
